import { ApiType } from "@gymflow/common";
import { StaffUserRole, UserStaffBean } from "@gymflow/types";
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";

import { staffQueryKeys } from "./staffQueryKeys";

export function useStaffChangeRole(
  {
    api,
  }: {
    api: ApiType;
  },
  mutationOpts?: UseMutationOptions<
    UserStaffBean,
    unknown,
    { staffId: string; role: StaffUserRole }
  >,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      staffId,
      role,
    }: {
      staffId: string;
      role: StaffUserRole;
    }) => {
      return (await api.staffApi.setRole(staffId, role)).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: staffQueryKeys.all(),
      });
    },
    ...mutationOpts,
  });
}
